import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useMutation, useQuery } from '@apollo/client'
import { useHistory, useParams } from 'react-router-dom'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import ContentHeader from '../../Layout/ContentHeader'
import { toastSweetAlert } from '../../Helpers/ToastSweetAlert'
import Box from '../../Global/Box'
import InputController from '../../Global/InputController'
import ConfigAppPageElements from './ConfigAppPageElements'
import { useLoading } from '../../../LoadingOverlay/LoadingOverlayContext'
import {
  CREATE_CONFIG_APP_PAGES,
  GET_ALL_CONFIG_APP_PAGES,
  GET_ONE_CONFIG_APP_PAGES,
  UPDATE_CONFIG_APP_PAGES,
} from '../../../graphql/ConfigApp/configAppPages'

const refetchConfigsAppPage = {
  query: GET_ALL_CONFIG_APP_PAGES,
  variables: {
    limit: 10,
    offset: 0,
    searchQuery: null,
  },
}
const backPage = '/ConfigApp/Pages'
const optionsVisible = [
  {
    value: true,
    label: 'Si',
  },
  {
    value: false,
    label: 'No',
  },
]

const ConfigAppPagesNew = () => {
  const { id: _id } = useParams()
  const history = useHistory()
  const { showLoading, hideLoading } = useLoading()

  //MUTATIONS:
  const [createConfigAppPage] = useMutation(CREATE_CONFIG_APP_PAGES, {
    refetchQueries: [{ ...refetchConfigsAppPage }],
  })

  const [updateConfigAppPage] = useMutation(UPDATE_CONFIG_APP_PAGES, {
    refetchQueries: [
      { ...refetchConfigsAppPage },
      { query: GET_ONE_CONFIG_APP_PAGES, variables: { id: parseInt(_id) } },
    ],
  })

  //QUERIES:
  const {
    data: dataResp,
    loading,
    error,
  } = useQuery(GET_ONE_CONFIG_APP_PAGES, {
    variables: {
      id: parseInt(_id),
    },
  })

  //FORM:
  const validationSchemaGeneral = Yup.object().shape({
    visible: Yup.string().required('Campo requerido'),
    name: Yup.string().required('Campo requerido'),
    description: Yup.string().required('Campo requerido'),
  })

  const {
    methods,
    handleSubmit,
    formState: { errors },
    control,
    reset,
  } = useForm({
    resolver: yupResolver(validationSchemaGeneral),
  })

  //EFFECTS:
  useEffect(() => {
    if (!loading) {
      if (_id) {
        if (error) {
          return toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        }

        if (dataResp !== undefined && dataResp !== null) {
          const data = dataResp.getOneConfigAppPage

          const dataFormated = {
            visible: data.visible,
            name: data.name ?? '',
            description: data.description ?? '',
          }

          reset(dataFormated)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id, dataResp, error, loading])

  const onSubmit = async (dataForm) => {
    const input = {
      name: dataForm.name,
      description: dataForm.description,
      visible: dataForm.visible === 'true' ? true : false,
    }

    showLoading()

    try {
      let message = ''

      if (_id) {
        await updateConfigAppPage({
          variables: { configAppPageId: parseInt(_id), input },
        })
        message = 'Se actualizo correctamente'
      } else {
        await createConfigAppPage({ variables: { input } })
        message = 'Se creo con exito'
      }

      return toastSweetAlert({ mode: 'ok', message }, history.push(backPage))
    } catch (error) {
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <ContentHeader
        title=""
        breadcrumb="custom"
        titleContent={
          <div className="col-12 col-sm-6">
            <Link className="btn btn-migrates-white" to={backPage}>
              <i className="fas fa-long-arrow-alt-left" /> Atrás
            </Link>
          </div>
        }
        breadcrumbContent={
          <div className="col-12 col-sm-6">
            <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item">
                <Link to={backPage}>Config. App Paginas / </Link>
              </li>
              <li className="breadcrumb-iteem active">
                {` `}
                {_id ? 'Editar' : 'Agregar'}
              </li>
            </ol>
          </div>
        }
        windowTitle={`${_id ? 'Editar' : 'Agregar'} pagina App`}
      />

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box
            title="Datos generales de la pagina"
            btnRedPath={backPage}
            btnRedTxt="Cancelar"
            errors={errors}
            btnSubmit={true}
            content={
              <div className="row">
                <div className="mb-3 col-12 col-sm-4 col-md-2">
                  <InputController
                    label="Visible"
                    name="visible"
                    control={control}
                    inputType="choosen"
                    options={optionsVisible}
                    placeholderTxt="Elige uno"
                    isClearable={true}
                  />
                </div>
                <div className="mb-3 col-12 col-sm-4 col-md-4">
                  <InputController
                    label="Nombre Pagina"
                    name="name"
                    type="text"
                    placeholderTxt="Escribe nombre"
                    control={control}
                  />
                </div>
                <div className="mb-3 col-12 col-sm-4 col-md-6">
                  <InputController
                    label="Descripcion"
                    name="description"
                    type="text"
                    placeholderTxt="Escribe descripcion"
                    control={control}
                  />
                </div>
              </div>
            }
          />
        </form>
      </FormProvider>

      {_id && <ConfigAppPageElements pageId={parseInt(_id)} />}
    </>
  )
}

export default ConfigAppPagesNew
